export default "__VITE_ASSET__5klrmQWW__"